import styled$1, { css } from 'styled-components';
import { Checkbox as Checkbox$1, hideVisually, colorSet, zIndex } from '@ccg/core';
import '@4rk/modular-system';
import { getTypography } from '../../styles/typography.js';
import React$1 from 'react';
import Tick from '../Icon/svgs/tick.js';
import { space } from '../../styles/spacing.js';

const getRectangle = (width, col) => css(["width:", "px;height:", "px;background-color:", ";position:relative;"], width, width, col);

const Checkbox = styled$1(Checkbox$1)`
  margin-bottom: ${space(2)};
  opacity: ${props => props.disabled && '0.5'};

  input {
    ${hideVisually}
  }

  label {
    display: flex;
    cursor: pointer;
  }

  .checkbox__custom-checkbox {
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    margin: ${space(2)};
    margin-left: 0;
    border: 2px solid ${colorSet('accent')};

    ${getRectangle(26, colorSet('background'))}
  }

  .checkbox__custom-checkbox-inner {
    position: relative;
    display: none;
    z-index: ${zIndex('base')};

    svg {
      fill: ${colorSet('accent')};
    }
  }

  .checkbox__label {
    display: block;
    margin-top: 2px;
    ${getTypography.copy}
  }

  .checkbox__optional {
    margin-left: ${space(2)};
    ${getTypography.small}
  }

  .checkbox__headline,
  .checkbox__error {
    display: block;
    ${getTypography.small}
  }

  .checkbox__error {
    color: ${colorSet('accent')};
  }

  input:checked + .checkbox__custom-checkbox .checkbox__custom-checkbox-inner {
    display: flex;
    align-items: center;
  }

  input[disabled] + .checkbox__custom-checkbox {
    background: ${colorSet('background')};
    border: 2px solid ${colorSet('color')};

    .checkbox__custom-checkbox-inner {
      display: none;
    }
  }
`;
Checkbox.defaultProps = {
  icon: /*#__PURE__*/React$1.createElement(Tick, null)
};

export default Checkbox;
